<template>
    <div id="app">
        <div class="sidenav" v-if="$store.state.auth.authenticated">
            <div class="top">
                <router-link
                    :to="{ name: 'dashboard' }"
                    active-class="active"
                    tag="a">
                    <icon icon="home" />
                </router-link>
                <router-link
                    :to="{ name: 'invoice.index' }"
                    class="nav-item"
                    active-class="active"
                    tag="a">
                    <icon icon="file" />
                    <span class="title">
                    {{ $t('invoice.invoices') }}
                </span>
                </router-link>
                <router-link
                    :to="{ name: 'customer.index' }"
                    class="nav-item"
                    active-class="active"
                    tag="a">
                    <icon icon="users" />
                    <span class="title">
                    {{ $t('customer.customers') }}
                </span>
                </router-link>
                <router-link
                    :to="{ name: 'product.index' }"
                    class="nav-item"
                    active-class="active"
                    tag="a">
                    <icon icon="package" />
                    <span class="title">
                    {{ $t('product.products') }}
                </span>
                </router-link>
            </div>
            <div class="bottom">
                <a href="#logout" @click.prevent="logout">
                    <icon icon="lock" />
                </a>
            </div>
            <slot name="sidenav"></slot>
        </div>
        <transition
            name="fade"
            mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>
<script>
    export default {
        /**
         * The name of the application.
         */
        name: 'billingsimo',

        /**
         * Fires when the app has been mounted.
         */
        mounted() {
            // If the user is authenticated,
            // fetch the data from the API
            if (this.$store.state.auth.authenticated) {
                this.$store.dispatch('account/find');
            }
        },

        methods: {
            logout() {
                this.$store.dispatch('auth/logout');
            },
        },
    };
</script>

<style lang="scss">
    $transition-in-duration: 400ms;
    $transition-out-duration: 200ms;

    .sidenav {
        height: 100vh;
        width: 80px;
        position: fixed;
        z-index: 1;
        top: 0;
        left: 0;
        background-color: #24292e;
        overflow-x: hidden;
        padding-top: 20px;
        text-align: left;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        transition: width $transition-out-duration;

        &:hover {
            width: 200px;
            transition: width $transition-in-duration;

            a {
                transition: color $transition-out-duration;

                &:hover {
                    color: #1d6daa;
                }

                &:first-child {
                    margin-left: 70px;
                    margin-bottom: 25px;
                    transition: margin $transition-in-duration;

                    .icon {
                        flex: 0 0 40px;
                        width: 40px;
                        height: 40px;
                        transition: all $transition-in-duration;
                    }
                }

                .title {
                    display: inline-block;
                    opacity: 1;
                }
            }
        }

        a {
            padding: 6px;
            text-decoration: none;
            font-size: 12pt;
            color: #ccc;
            display: flex;
            margin-left: 20px;
            margin-top: 5px;
            margin-bottom: 5px;
            transition: margin-left $transition-out-duration;

            &.active {
                color: #1d6daa;
            }

            &.nav-item {
                height: 32px;
            }

            &:first-child {
                display: inline-block;
                color: #545f6f;
                margin-bottom: 40px;
                transition: margin $transition-out-duration;

                &:hover {
                    color: #fff;
                }

                .icon {
                    transition: all $transition-out-duration;
                }
            }

            .title {
                flex: 1;
                display: none;
                opacity: 0;
            }

            .icon {
                flex: 0 0 25px;
                margin-right: 10px;
                width: 25px;
                height: 25px;
            }
        }

        .align-bottom {
            a:first-child {
                align-self: flex-end;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue?af31717e